export default __webpack_public_path__ + "static/media/042-Tooth Brush.029f4469.svg";